import { render } from "./MoveModal.vue?vue&type=template&id=0b3b1cdb"
import script from "./MoveModal.vue?vue&type=script&lang=js"
export * from "./MoveModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__